import { useQuery } from '@tanstack/react-query';
import type { GroupLinkPreviewDto } from '@mondy/shared';
import { api } from '@/api';

interface GroupLinkPreviewResponse {
  preview: GroupLinkPreviewDto;
}

/**
 * Unauthenticated (but opportunistic-bearer): preview a group shortId invite
 * link. The `viewerState.kind` field tells the UI which state machine branch
 * to render (anonymous / none / pending / member).
 *
 * `staleTime: 0` because the state transitions (anonymous → none after login,
 * none → pending after request-to-join) rely on refetching — don't serve
 * stale data from cache across those flips.
 */
export function useGroupLinkPreview(shortId: string | null) {
  return useQuery({
    queryKey: ['groups', 'by-short-id', shortId] as const,
    queryFn: () =>
      api.get<GroupLinkPreviewResponse>(
        `/api/groups/by-short-id/${encodeURIComponent(shortId ?? '')}`,
      ),
    enabled: Boolean(shortId),
    retry: false,
    staleTime: 0,
  });
}
